import { useTranslation } from "react-i18next";

import { Loader2 } from "@/shared/ui/icons";

export function AuthLoadingScreen() {
  const { t } = useTranslation();
  return (
    <div className="flex h-full items-center justify-center bg-canvas">
      <div className="flex flex-col items-center gap-4 text-muted" role="status">
        <Loader2 className="h-8 w-8 animate-spin" aria-hidden />
        <p className="text-[15px]">{t("common.loading")}</p>
      </div>
    </div>
  );
}
